import { render, staticRenderFns } from "./Links.vue?vue&type=template&id=29822d79&"
import script from "./Links.vue?vue&type=script&lang=js&"
export * from "./Links.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports